"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatBanner = require("../../utils/formatBanner");
var _intlDesignUi = require("@tencent/intl-design-ui");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatBannerCommon = (0, _formatBanner.formatBannerCommon)(data, {
        domains
      }),
      title = _formatBannerCommon.title,
      content = _formatBannerCommon.content,
      backgroundUrl = _formatBannerCommon.backgroundUrl,
      backgroundMbUrl = _formatBannerCommon.backgroundMbUrl,
      buttonList = _formatBannerCommon.buttonList,
      tagText = _formatBannerCommon.tagText,
      tagHref = _formatBannerCommon.tagHref;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      className: "gems-materials-qci__overview-banner"
    }, (0, _reportUtil.reportShow)(['show_OverviewBanner', componentKey, title])), /*#__PURE__*/React.createElement(_intlDesignUi.OverViewBanner, {
      title: title,
      content: content,
      backgroundUrl: backgroundUrl,
      backgroundMbUrl: backgroundMbUrl,
      buttonList: buttonList,
      tagText: tagText,
      tagHref: tagHref,
      onCallback: item => {
        // 解决方案只有合作伙伴页才需要这个逻辑
        if (window.location.href.indexOf('partner') === -1 || item.href.indexOf('partners') === -1) {
          window.asyncReceiveCommodity(item);
          return;
        }
        window.checkAccountType();
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}